<template>
  <div class="contact-banner">
    <img :src="mobilecontactBanner" alt="" />
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilecontactBanner from "../../../assets/contact/mobilecontactBanner.png";

export default {
  setup() {
    return reactive({
      mobilecontactBanner: mobilecontactBanner,
    });
  },
};
</script>

<style scoped>
.contact-banner img {
  width: 100%;
  height: 160px;
}
</style>
